import { List,Record } from "immutable";

import createFromJS from "../../createFromJS";

export const StandardDataRecord = Record({
  items: List(),
  relationships: List()
});

const data = {
  collections: {
    items: "StandardItemRecord",
    relationships: "StandardRelationshipRecord"
  }
};
createFromJS.registerCallback("StandardDataRecord", createFromJS.createNestedCallback(StandardDataRecord, data));
